import React, { useCallback, useEffect, useMemo, useState } from "react";

import Counter from "./Counter";
import {
  Circle,
  CounterWrapper,
  InnerCircle,
  MoreInfo,
  ResultCircle,
  ResultWrapper,
  Text,
  Water,
} from "./styles";

export enum ResultType {
  percent = "percent",
  count = "count",
}

export type ResultGlassProps = {
  type: ResultType;
  resultText?: string;
  userVoteCount: number;
  totalVoteCount: number;
  showDetails: boolean;
};

const ResultGlass: React.FC<ResultGlassProps> = ({
  type,
  resultText,
  userVoteCount,
  totalVoteCount,
  showDetails,
}) => {
  const [animation, setAnimation] = useState(false);

  const percent = useMemo(
    () => Math.round((userVoteCount / totalVoteCount) * 100),
    [userVoteCount, totalVoteCount]
  );

  useEffect(() => {
    // Get another keyframe
    const timer = setTimeout(() => setAnimation(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const renderCount = useCallback((): React.JSX.Element => {
    if (type === ResultType.count) {
      return (
        <React.Fragment>
          {animation && (
            <CounterWrapper>
              <h1>
                {userVoteCount} / {totalVoteCount}
              </h1>
            </CounterWrapper>
          )}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {animation && (
            <CounterWrapper>
              <Counter start={0} end={percent} duration={2000}>
                {(value: number) => <span>{value || 0}%</span>}
              </Counter>
            </CounterWrapper>
          )}
        </React.Fragment>
      );
    }
  }, [animation, type, userVoteCount, totalVoteCount, percent]);

  return (
    <Circle>
      <InnerCircle>
        <Water percent={animation ? percent : 0} />
        {animation && (
          <ResultWrapper>
            <ResultCircle>
              {renderCount()}
              <MoreInfo>
                {showDetails && (
                  <Text>
                    <span>{userVoteCount.toLocaleString()}</span> von{" "}
                    <span>{totalVoteCount.toLocaleString()}</span>
                  </Text>
                )}
                {resultText && <Text>{resultText}</Text>}
              </MoreInfo>
            </ResultCircle>
          </ResultWrapper>
        )}
      </InnerCircle>
    </Circle>
  );
};

export default ResultGlass;
